<div
  class="section-wrapper"
  [class.section-wrapper--selectable]="section().sectionId !== null"
  [class.section-wrapper--selected]="sectionFilter()?.sectionIds.includes(section().sectionId)"
  [class.section-wrapper--last-section]="isLastSection()"
>
  <div class="section">
    <div class="section-label" [class.section-label--multi-row]="section().segment?.length">
      <div class="section-speaker">
        <span>{{ section().title }}</span>
      </div>

      <div class="section-date">
        {{ section().date | lexDate: 'xiLong12' }}
      </div>

      @if (section().value) {
        <xi-icon-button
          [icon]="isExpanded() ? 'single_arrow_up' : 'single_arrow_down'"
          (onClick)="toggleExpansion($event)"
        ></xi-icon-button>
      }

      @if (section().segment) {
        <div class="section-segment-wrapper">
          @for (segment of section().segment; track segment) {
            <span class="section-segment">
              {{ segment }}
            </span>
          }
        </div>
      }
    </div>

    @if (isExpanded()) {
      <div class="section-text-wrapper">
        @if (!isPlaybackDisabled() && section().playbackDisplay) {
          <div (click)="onSectionTextClicked()" class="section-playback-offset">
            {{ section().playbackDisplay }}
          </div>
        }
        <div
          class="section-text"
          (click)="onSectionTextClicked()"
          [innerHTML]="section().value"
        ></div>
      </div>
    }
  </div>
</div>
